import { Candle } from ".";

export const updateCandle = (candle: Candle) => {

};